"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
    _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _Icon = _interopRequireDefault(require("../../../Icon")),
    _formModal = require("../../styles/formModal");

function ModalHeader(a) {
  var b = a.title,
      c = a.subtitle,
      d = a.showBackBtn,
      e = a.onBackClick;
  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])(_formModal.HEADER, "modal__header")
  }, _react["default"].createElement("div", null, d ? _react["default"].createElement(_Icon["default"], {
    clickable: e,
    className: _formModal.BACK_ICON,
    name: "return",
    onClick: e,
    size: 20,
    color: "regent"
  }) : null), _react["default"].createElement("div", {
    className: (0, _classnames["default"])(_formModal.HEADER_TEXT, "modal__header__text")
  }, _react["default"].createElement("h1", null, b), _react["default"].createElement("p", null, c)));
}

var _default = (0, _react.memo)(ModalHeader);

exports["default"] = _default;